import { React, useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import TokenService from '../../services/TokenService'
import IconButton from '@mui/material/IconButton';
import { useSnackbar } from 'notistack';
import Button from '@mui/material/Button';
import MapIcon from '@mui/icons-material/Map';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import WrongLocationIcon from '@mui/icons-material/WrongLocation';
import Fab from '@mui/material/Fab';
import AddZipcode from '../Modals/AddZipcode';
import ViewZipcodeBoundry from '../Modals/ViewZipcodeBoundry';
import ConfirmDialog from '../Modals/ConfirmDialog';
import AdvancedServiceAreas from './AdvancedServiceAreas'
import styles from './MyAccount.module.css'; // Import css modules stylesheet as styles

function ServiceAreas(props) {

    useEffect(() => {
        if (props.loggedInUser !== null && props.loggedInUser !== undefined) {
            // props changed

        }
    }, [props]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [selectedTab, setSelectedTab] = useState('1');
    const [showAddZipcodePrompt, setShowAddZipcodePrompt] = useState(false);

    const [showZipcodeBoundry, setShowZipcodeBoundry] = useState('');

    const [confirmDialog, setConfirmDialog] = useState(null);

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    function buildSkeleton() {
        return <div>
            <div>Service Areas</div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center' }} />
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginLeft: '30px' }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center' }} />
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginLeft: '30px' }} />
            </div>
        </div>
    }

    function buildZipcodesPanel() {
        return <div>
          

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                <div style={{ fontSize: '10pt' }}>
                    Adding zipcodes is the simplest way specify your service area.
                </div>
                <Fab aria-label="More Info" onClick={() => setShowAddZipcodePrompt(true)} style={{ minWidth:'45px', width:'45px', height:'45px' }}>
                    <AddLocationIcon sx={{ color: 'var(--sipzee-green)', fontSize: 40 }} />
                </Fab>
            </div>

            {buildZipcodeAreas()}
            
    

        </div>
    }

    function buildZipcodeAreas() {
        let zipcodesCount = 0;
        let zipItems = [];
        for (let i = 0; i < props.loggedInUser.ServiceAreas.length; i++) {
            if (props.loggedInUser.ServiceAreas[i].AreaType == 1) {
                zipcodesCount++;
                let zipCode = props.loggedInUser.ServiceAreas[i].Zipcode;
                zipItems.push(<div key={props.loggedInUser.ServiceAreas[i].ServiceAreaId} style={{display:'flex', justifyContent:'space-between', marginBottom:'5px'} }>
                    <span style={{alignSelf:'center', fontWeight:'bold'} }>{props.loggedInUser.ServiceAreas[i].Zipcode}</span>
                    <Button variant='outlined' onClick={(e) => showZipcodeBoundryModal(zipCode) }>View Zip</Button>
                    <Fab style={{ height: '40px', width: '40px' }} onClick={(e) => confirmDeleteZipcode(props.loggedInUser.ServiceAreas[i]) }>
                        <WrongLocationIcon sx={{ color: 'var(--sipzee-red)', fontSize: 30 }} />
                    </Fab>
                </div>);
            }
        }

        if (zipcodesCount == 0) {
            zipItems.push(<div>You have not added any Zip Codes</div>);
        }

        return zipItems;
        
    }

    function handleAddZipcodeClosed(serviceArea) {

        if (typeof serviceArea === 'object')
        {
            props.loggedInUser.ServiceAreas.push(serviceArea);
            props.onChange(props.loggedInUser);
        }
        setShowAddZipcodePrompt(false);
    }

    function confirmDeleteZipcode(serviceArea) {
        if (serviceArea !== null) {
            setConfirmDialog({

                Close: (didAccept, serviceArea) => {
                    // Close callback
                    setConfirmDialog(null);
                    if (didAccept && serviceArea !== undefined) {
                        let postData = {
                            serviceAreaId: serviceArea.ServiceAreaId
                        }

                        TokenService.post(postData, 'DeleteServiceArea')
                            .then((response) => {
                                response = response[Object.keys(response)[0]];
                                if (response.Result == "SUCCESS") {

                                    // response is the deleted service area
                                    for (let i = 0; i < props.loggedInUser.ServiceAreas.length; i++) {
                                        if (response.ServiceAreaId === props.loggedInUser.ServiceAreas[i].ServiceAreaId) {
                                            // remove this servicearea
                                            props.loggedInUser.ServiceAreas.splice(i, 1);
                                            break;
                                        }
                                    }
                                    props.onChange(props.loggedInUser);
                                    let jsonData = JSON.parse(response.JsonData);
                                    let level = JSON.parse(jsonData.ReturnerLevel);
                                    let event = new CustomEvent('ReturnerLevel_Updated', {
                                        detail: level
                                    });
                                    document.getElementsByTagName('body')[0].dispatchEvent(event);
                                }
                            })
                            .catch((response) => {
                                enqueueSnackbar('Oops, something went wrong', {
                                    variant: 'error',
                                });
                            });
                    }
                },
                Title : 'Delete Zip?',
                Content: <div>Delete your service area for {serviceArea.Zipcode }?</div >,
                CancelText : 'Cancel',
                AcceptText: 'Delete',
                Data: serviceArea
            })
        }
    }

    function showZipcodeBoundryModal(zipcode) {
        setShowZipcodeBoundry(zipcode)
    }

    function buildAdvancedPanel() {
        return <div>
            <AdvancedServiceAreas onChange={props.onChange} loggedInUser={props.loggedInUser }/>
        </div>
    }

    function buildContent() {
        return <div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ fontSize: '14pt', fontWeight: 'bold', marginBottom: '10px' }}>My Service Area</div>
                <MapIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30 }} />
            </div>
            <div style={{color:'var(--sipzee-red)', fontSize:'10pt'} }>
                Sipzee is only serving Michigan at this time
            </div>

            <TabContext  value={selectedTab} >
                
                <TabList
                    className="tabHeader"
                    variant="fullWidth"
                    textColor="primary"
                    indicatorColor="secondary"
                    onChange={handleChange} aria-label="Service Areas Tabs">
                    <Tab style={{ fontWeight: 'bold' }} label="Zip codes" value="1" />
                    <Tab style={{ fontWeight: 'bold' }} label="Advanced" value="2" />
                </TabList>
                
                <TabPanel value="1" style={{padding:'10px'} }>{buildZipcodesPanel()}</TabPanel>
                <TabPanel value="2" style={{ padding: '0px' }}>{buildAdvancedPanel()}</TabPanel>
            </TabContext>
        </div>
    }

    return (
        <Card sx={{ minWidth: 300, maxWidth: 400, width:'95%', alignSelf: 'center', margin: '10px', minHeight:500 }}>
            <CardContent>
                {props.loggedInUser == null ? buildSkeleton() : buildContent()}
            </CardContent>
            {showAddZipcodePrompt ?
                <AddZipcode Close={(zipcode) => handleAddZipcodeClosed(zipcode)} ExistingZipcodes={props.loggedInUser.ServiceAreas} />
                : null
            }
            {showZipcodeBoundry !== '' ?
                <ViewZipcodeBoundry Close={() => setShowZipcodeBoundry('')} Zipcode={showZipcodeBoundry} />
                : null
            }
            {
                confirmDialog !== null ?
                    <ConfirmDialog Close={confirmDialog.Close} Title={confirmDialog.Title} Content={confirmDialog.Content} CancelText={confirmDialog.CancelText} AcceptText={confirmDialog.AcceptText} Data={confirmDialog.Data } />
                    :null
            }
        </Card>
    );
}
export default ServiceAreas;